import React from 'react';
import { steps } from '../data/content';
export function HowItWorks() {
  return <section aria-labelledby="como-titulo" className="w-full bg-white py-16 sm:py-24" data-id="element-97" data-mp="7slq0yyp41rl">
      <div className="mx-auto w-full max-w-6xl px-5 sm:px-8" data-id="element-98" data-mp="3pyhwt68rkd3a">
        <h2 id="como-titulo" className="max-w-2xl font-display text-3xl font-extrabold uppercase leading-tight tracking-tight text-ink sm:text-4xl" data-id="element-99" data-mp="3q02rqwyzpy1o">
          Cómo funciona, en tres pasos
        </h2>

        <ol className="relative mt-12 grid gap-10 md:grid-cols-3 md:gap-8" data-id="element-100" data-mp="lmmi59v56qiz">
          <span aria-hidden="true" className="absolute left-5 top-2 hidden h-px w-full bg-sand-200 md:block" data-id="element-101" data-mp="qil7azoaockg" />
          {steps.map((step, index) => <li key={step.title} className="relative" data-id="element-102" data-mp="gs0fpw71g8b1" data-mpi={index}>
              <span className="relative z-10 flex h-10 w-10 items-center justify-center rounded-full bg-navy-900 font-display text-base font-bold text-white" data-id="element-103" data-mp="14imails17w33">
                {index + 1}
              </span>
              <h3 className="mt-5 font-display text-xl font-bold leading-snug text-ink" data-id="element-104" data-mp="2rkwdky870bmw">
                {step.title}
              </h3>
              <p className="mt-2 text-base leading-relaxed text-ink/70" data-id="element-105" data-mp="2mo5vk5ctv5yu">{step.body}</p>
            </li>)}
        </ol>
      </div>
    </section>;
}